import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as KEnableActions from 'src/app/components/kenable/store/ke/kenable.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class KEnableStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new KEnableActions.KEnableRefresh());
  }

  initListeners() {
    // KEnable
    this.signalRService.hubConnection?.on(Channels.KENABLE, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {

        case SignalRAction.Get:
          this.store.dispatch(new KEnableActions.KEnableRefresh());
          break;

        case SignalRAction.Add:
          this.store.dispatch(new KEnableActions.KEnableCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new KEnableActions.KEnableUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new KEnableActions.KEnableDelete(data.id));
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new KEnableActions.KEnableRefreshByID(data.id));
      }
    });
  }
}
